/* ==========================================================================
   Akmas product page, assets/akmas-pdp.js
   Vanilla ES2019, no dependencies. Everything is guarded so the file can be
   loaded on any template without errors. Cart calls go through the global
   window.AkmasCart module (assets/akmas-cart.js, loaded site-wide).
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('.akp');
  if (!root) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------
     Helpers
     ------------------------------------------------------------------ */
  function money(cents) {
    if (window.AkmasCart && typeof window.AkmasCart.formatMoney === 'function') {
      return window.AkmasCart.formatMoney(cents);
    }
    var currency = (window.AkmasOffers && window.AkmasOffers.currency) || 'INR';
    var symbol = currency === 'INR' ? '₹' : '';
    return symbol + (Math.round(cents / 100) ).toLocaleString();
  }

  function offerConfig() {
    return (
      window.AkmasOffers || {
        bundles: { 1: 79900, 2: 99900, 3: 129900 },
        compareAt: 129900,
        prepaidPercent: 5,
        codFee: 4900
      }
    );
  }

  /* ------------------------------------------------------------------
     Gallery: scroll-snap carousel, thumbs, counter, fullscreen zoom
     ------------------------------------------------------------------ */
  (function gallery() {
    var wrap = root.querySelector('[data-akp-gallery]');
    if (!wrap) return;
    var track = wrap.querySelector('[data-akp-track]');
    var main = wrap.querySelector('[data-akp-main]');
    var counter = wrap.querySelector('[data-akp-counter]');
    var slides = Array.prototype.slice.call(wrap.querySelectorAll('[data-akp-slide]'));
    var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('[data-akp-thumb]'));
    if (!track || !slides.length) return;

    var current = Math.max(
      0,
      thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; })
    );
    if (current === -1) current = 0;

    function slideImage(i) {
      var slide = slides[i];
      if (!slide) return '';
      var img = slide.querySelector('img');
      if (img) return img.currentSrc || img.src || '';
      // Fallback: try to find source
      var source = slide.querySelector('source');
      if (source && source.srcset) {
        var srcset = source.srcset.split(',')[0].trim().split(' ')[0];
        if (srcset) return srcset;
      }
      return '';
    }

    function slideAlt(i) {
      var img = slides[i] && slides[i].querySelector('img');
      return img ? img.alt : '';
    }

    function setCurrent(i) {
      current = Math.min(Math.max(i, 0), slides.length - 1);
      if (counter) counter.textContent = current + 1 + '/' + slides.length;
      thumbs.forEach(function (el, idx) {
        el.setAttribute('aria-current', String(idx === current));
        if (idx === current && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
    }

    /* Track which slide is in view (native scroll-snap does the motion). */
    var scrollTimer = null;
    track.addEventListener(
      'scroll',
      function () {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var idx = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          if (idx !== current) setCurrent(idx);
        }, 90);
      },
      { passive: true }
    );

    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () {
        track.scrollTo({ left: idx * track.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
        setCurrent(idx);
      });
    });

    /* Fullscreen zoom, tap/click a slide. */
    var zoom = root.querySelector('[data-akp-zoom]');
    var zoomImg = zoom ? zoom.querySelector('[data-akp-zoom-img]') : null;
    var zoomCounter = zoom ? zoom.querySelector('[data-akp-zoom-counter]') : null;
    var zoomClose = zoom ? zoom.querySelector('[data-akp-zoom-close]') : null;
    var lastFocus = null;

    function openZoom() {
      if (!zoom || !zoomImg) return;
      var imgSrc = slideImage(current);
      if (!imgSrc) return;
      zoomImg.src = imgSrc;
      zoomImg.alt = slideAlt(current) || '';
      if (zoomCounter) zoomCounter.textContent = current + 1 + '/' + slides.length;
      lastFocus = document.activeElement;
      zoom.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (zoomClose) zoomClose.focus();
      document.addEventListener('keydown', onZoomKey);
    }

    function closeZoom() {
      if (!zoom) return;
      zoom.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onZoomKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onZoomKey(e) {
      if (e.key === 'Escape') closeZoom();
    }

    if (main) {
      main.addEventListener('click', function (e) {
        var img = e.target.closest('img');
        if (!img || !slideImage(current)) return;
        openZoom();
      });
    }
    if (zoomClose) zoomClose.addEventListener('click', closeZoom);
    if (zoom) {
      zoom.addEventListener('click', function (e) {
        if (e.target === zoom) closeZoom();
      });
    }
  })();

  /* ------------------------------------------------------------------
     Variant JSON + form wiring
     ------------------------------------------------------------------ */
  var variantsEl = document.querySelector('[data-akp-variants]');
  var variants = [];
  try {
    variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  } catch (e) { variants = []; }

  var form = root.querySelector('[data-akp-form]');
  var variantInput = form ? form.querySelector('[data-akp-variant-id]') : null;
  var qtyInput = form ? form.querySelector('[data-akp-qty-input]') : null;
  var submitBtn = form ? form.querySelector('[data-akp-atc]') : null;
  var priceWrap = root.querySelector('[data-akp-price]');
  var stickyPrice = root.querySelector('[data-akp-sticky-price]');
  var stickyCompare = root.querySelector('[data-akp-sticky-compare]');
  var stickySave = root.querySelector('[data-akp-sticky-save]');
  var stickyAtc = root.querySelector('[data-akp-sticky-atc]');
  var stickyVariant = root.querySelector('[data-akp-sticky-variant]');
  var atcStatus = root.querySelector('[data-akp-atc-status]');
  var stockLine = root.querySelector('[data-akp-stock]');
  var isSoap = root.getAttribute('data-akp-is-soap') === 'true';
  var isAdding = false;

  function currentVariant() {
    var id = variantInput ? variantInput.value : null;
    return variants.find(function (v) { return String(v.id) === String(id); }) || variants[0] || null;
  }

  function variantLabel(v) {
    if (!v || !v.title || v.title === 'Default Title') return '';
    return v.title;
  }

  function setQty(n) {
    if (!qtyInput) return;
    qtyInput.value = String(Math.max(1, n));
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    if (!isAdding) resetAtcButtons();
  }

  function announce(message) {
    if (atcStatus) atcStatus.textContent = message;
  }

  function selectedTotal() {
    var v = currentVariant();
    var quantity = parseInt(qtyInput && qtyInput.value, 10) || 1;
    if (!v) return 0;
    if (!isSoap) {
      var bundles = offerConfig().bundles || {};
      var bundlePrice = bundles[quantity];
      if (quantity >= 1 && quantity <= 3 && typeof bundlePrice === 'number' && bundlePrice > 0) {
        return bundlePrice;
      }
    }
    return v.price * quantity;
  }

  function resetAtcButtons() {
    var v = currentVariant();
    var available = v ? v.available : true;
    var quantity = parseInt(qtyInput && qtyInput.value, 10) || 1;
    if (submitBtn) {
      submitBtn.removeAttribute('data-state');
      submitBtn.removeAttribute('aria-busy');
      submitBtn.disabled = !available;
      submitBtn.textContent = available && v
        ? (quantity > 1 ? 'Add ' + quantity + ' to cart ' + money(selectedTotal()) : 'Add to cart ' + money(selectedTotal()))
        : 'Sold out';
    }
    if (stickyAtc) {
      stickyAtc.removeAttribute('data-state');
      stickyAtc.removeAttribute('aria-busy');
      stickyAtc.disabled = !available;
      stickyAtc.textContent = available ? 'Add to cart' : 'Sold out';
    }
  }

  function setAtcBusy(state, label) {
    [submitBtn, stickyAtc].forEach(function (btn) {
      if (!btn) return;
      if (state) {
        btn.setAttribute('data-state', state);
        btn.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
        btn.textContent = label;
      }
    });
  }

  function addCurrentToCart() {
    if (isAdding) return;
    var id = variantInput ? variantInput.value : null;
    var quantity = parseInt(qtyInput && qtyInput.value, 10) || 1;
    var v = currentVariant();
    if (v && !v.available) return;

    if (!id || !window.AkmasCart || typeof window.AkmasCart.addItems !== 'function') {
      if (form) form.submit();
      return;
    }

    isAdding = true;
    if (submitBtn) submitBtn.disabled = true;
    if (stickyAtc) stickyAtc.disabled = true;
    setAtcBusy('loading', 'Adding…');
    announce('Adding to cart…');

    window.AkmasCart.addItems([{ id: id, quantity: quantity }])
      .then(function () {
        var drawer = document.querySelector('akmas-cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open(stickyAtc || submitBtn);
        setAtcBusy('added', 'Added');
        announce('Added to cart.');
        refreshTiers();
        window.setTimeout(resetAtcButtons, 1600);
      })
      .catch(function (err) {
        console.warn('[akp] add to cart failed', err);
        setAtcBusy('error', 'Try again');
        if (submitBtn) submitBtn.disabled = false;
        if (stickyAtc) stickyAtc.disabled = false;
        announce('Could not add to cart. Please try again.');
        window.setTimeout(resetAtcButtons, 2600);
      })
      .finally(function () {
        isAdding = false;
      });
  }

  function refreshVariantUI() {
    var v = currentVariant();
    if (!v) return;

    if (priceWrap) {
      var html = '<span class="akp-price">' + money(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += '<span class="akp-price--compare">' + money(v.compare_at_price) + '</span>';
        var pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
        if (pct > 0) html += '<span class="akp-save-chip">−' + pct + '%</span>';
      }
      priceWrap.innerHTML = html;
    }
    if (stickyPrice) stickyPrice.textContent = money(v.price);
    if (stickyVariant) {
      var vLabel = variantLabel(v);
      stickyVariant.textContent = vLabel;
      stickyVariant.hidden = !vLabel;
    }
    var offersCfg = offerConfig();
    var stickyBaseline = 0;
    if (v.compare_at_price && v.compare_at_price > v.price) stickyBaseline = v.compare_at_price;
    else if (!isSoap && offersCfg.compareAt && offersCfg.compareAt > v.price) stickyBaseline = offersCfg.compareAt;
    var stickySaveCents = stickyBaseline - v.price;
    if (stickyCompare) {
      if (stickySaveCents > 0) {
        stickyCompare.textContent = money(stickyBaseline);
        stickyCompare.hidden = false;
      } else {
        stickyCompare.hidden = true;
      }
    }
    if (stickySave) {
      if (stickySaveCents > 0) {
        stickySave.textContent = 'Save ' + money(stickySaveCents);
        stickySave.hidden = false;
      } else {
        stickySave.hidden = true;
      }
    }
    if (!isAdding) resetAtcButtons();
    if (stockLine) {
      var left = v.inventory_quantity;
      if (v.available && typeof left === 'number' && left > 0 && left <= 10) {
        stockLine.textContent = 'Only ' + left + ' left in stock, order soon';
        stockLine.hidden = false;
      } else {
        stockLine.hidden = true;
      }
    }
    var sizeLabel = root.querySelector('[data-akp-size-label]');
    if (sizeLabel) {
      var opt = v.option1 || v.title || '';
      sizeLabel.textContent = opt;
    }
  }

  if (form && qtyInput) {
    form.querySelectorAll('[data-akp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty((parseInt(qtyInput.value, 10) || 1) + Number(btn.getAttribute('data-akp-qty')));
      });
    });

    /* Size / option pills */
    root.querySelectorAll('[data-akp-option-pill]').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input) return;
      input.addEventListener('change', function () {
        var group = input.getAttribute('data-option-name');
        root.querySelectorAll('input[data-option-name="' + group + '"]').forEach(function (other) {
          if (other !== input && other.checked) other.checked = false;
        });
        /* Compose a variant id from the checked values of every option group. */
        var picked = {};
        root.querySelectorAll('[data-akp-option-pill] input:checked').forEach(function (c) {
          picked[c.getAttribute('data-option-name')] = c.value;
        });
        var match = variants.find(function (v) {
          return Object.keys(picked).every(function (k) { return String(v['option' + (k)]) === String(picked[k]); });
        });
        if (match) {
          variantInput.value = match.id;
          refreshVariantUI();
        }
      });
    });

    /* Buy now: add the current variant, then go straight to checkout. */
    (function buyNow() {
      var btn = root.querySelector('[data-akp-buynow]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var id = variantInput ? variantInput.value : null;
        var quantity = parseInt(qtyInput && qtyInput.value, 10) || 1;
        if (!id || !window.AkmasCart) {
          if (form) form.submit();
          return;
        }
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        window.AkmasCart.addItems([{ id: id, quantity: quantity }])
          .then(function () {
            window.location.assign('/checkout');
          })
          .catch(function (err) {
            console.warn('[akp] buy now failed', err);
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          });
      });
    })();

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      addCurrentToCart();
    });
  }

  refreshVariantUI();

  /* ------------------------------------------------------------------
     Bundle selector. It sets the same quantity field the form and sticky
     bar read, so price, quantity and add-to-cart stay in sync.
     ------------------------------------------------------------------ */
  (function bundle() {
    var box = root.querySelector('[data-akp-bundle]');
    if (!box) return;
    var nudge = root.querySelector('[data-akp-bundle-nudge]');
    var steps = Array.prototype.slice.call(box.querySelectorAll('[data-akp-tier]'));
    var offers = offerConfig();
    var bundles = offers.bundles || { 1: 79900, 2: 99900, 3: 129900 };

    function paintSelection() {
      var quantity = parseInt(qtyInput && qtyInput.value, 10) || 1;
      steps.forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(Number(btn.getAttribute('data-akp-tier')) === quantity));
      });
      if (!isAdding) resetAtcButtons();
      if (!nudge) return;
      if (quantity >= 3) {
        nudge.textContent = 'Best bundle price selected.';
      } else if (quantity === 2) {
        nudge.innerHTML = 'Add 1 more to pay <strong>' + money(bundles[3]) + '</strong> for 3.';
      } else {
        nudge.innerHTML = 'Add 1 more to pay <strong>' + money(bundles[2]) + '</strong> for 2.';
      }
    }

    steps.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty(Number(btn.getAttribute('data-akp-tier')));
        paintSelection();
      });
    });

    if (qtyInput) {
      qtyInput.addEventListener('input', paintSelection);
      qtyInput.addEventListener('change', paintSelection);
    }

    paintSelection();

    window.refreshTiers = function refreshTiersLocal() {
      if (!window.AkmasCart || typeof window.AkmasCart.fetchCart !== 'function') return;
      window.AkmasCart.fetchCart()
        .then(function (cart) {
          var state = window.AkmasCart.tierState(cart);
          var layerNudge = root.querySelector('[data-akp-layer-nudge]');
          if (layerNudge) {
            if (state.stage >= 3) {
              layerNudge.innerHTML = 'Best bundle price unlocked. Anything you add now stays at <strong>' + money(offers.bundles[3]) + '</strong> for 3.';
            } else if (state.stage === 2) {
              layerNudge.innerHTML = 'Add 1 more to pay <strong>' + money(offers.bundles[3]) + '</strong> for 3.';
            } else if (state.stage === 1) {
              layerNudge.innerHTML = 'Add 1 more to pay <strong>' + money(offers.bundles[2]) + '</strong> for 2.';
            } else {
              layerNudge.innerHTML = 'Any 2 for <strong>' + money(offers.bundles[2]) + '</strong> · any 3 for <strong>' + money(offers.bundles[3]) + '</strong>.';
            }
          }
        })
        .catch(function () { /* keep the server-rendered state */ });
    };
    window.refreshTiers();

    document.addEventListener('akmas:cart-updated', function () {
      if (window.refreshTiers) window.refreshTiers();
    });
    document.addEventListener('cart:updated', function () {
      if (window.refreshTiers) window.refreshTiers();
    });
  })();

  /* ------------------------------------------------------------------
     Notes tabs: click a tab or swipe the panels; keep the two in sync.
     ------------------------------------------------------------------ */
  (function notes() {
    var block = root.querySelector('[data-akp-notes]');
    if (!block) return;
    var tabs = Array.prototype.slice.call(block.querySelectorAll('[data-akp-notes-tab]'));
    var wrap = block.querySelector('[data-akp-notes-panels]');
    if (!tabs.length || !wrap) return;
    var panels = Array.prototype.slice.call(wrap.querySelectorAll('[data-akp-notes-panel]'));
    if (!panels.length) return;

    function activate(index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', String(on));
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });
    }

    function goTo(index, smooth) {
      if (!panels[index]) return;
      wrap.scrollTo({
        left: index * wrap.clientWidth,
        behavior: smooth && !reducedMotion ? 'smooth' : 'auto'
      });
      activate(index);
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { goTo(i, true); });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var next = e.key === 'ArrowRight' ? Math.min(i + 1, tabs.length - 1) : Math.max(i - 1, 0);
        tabs[next].focus();
        goTo(next, true);
      });
    });

    var scrollTimer = null;
    wrap.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var idx = Math.round(wrap.scrollLeft / Math.max(wrap.clientWidth, 1));
        if (idx >= 0 && idx < tabs.length) activate(idx);
      }, 90);
    }, { passive: true });
  })();

  function refreshTiers() {
    if (window.refreshTiers) window.refreshTiers();
  }

  /* ------------------------------------------------------------------
     Mobile purchase dock: fixed carousel + sticky bar. The measured
     height becomes body padding so content is never hidden behind it.
     ------------------------------------------------------------------ */
  (function dock() {
    var dockEl = root.querySelector('[data-akp-dock]');
    if (!dockEl) return;

    document.body.classList.add('akp-dock-on');

    function measure() {
      var height = Math.ceil(dockEl.getBoundingClientRect().height);
      if (height > 0) {
        document.documentElement.style.setProperty('--akp-dock-height', height + 'px');
      }
    }

    measure();
    if ('ResizeObserver' in window) {
      new ResizeObserver(measure).observe(dockEl);
    } else {
      window.addEventListener('resize', measure);
    }
    window.addEventListener('load', measure);

    if (stickyAtc) stickyAtc.addEventListener('click', addCurrentToCart);
  })();

  /* ------------------------------------------------------------------
     Pincode estimate (config-driven; no external API)
     ------------------------------------------------------------------ */
  (function pincode() {
    var box = root.querySelector('[data-akp-pincode]');
    if (!box) return;
    var input = box.querySelector('input');
    var btn = box.querySelector('button');
    var out = box.querySelector('[data-akp-pincode-result]');
    var minDays = parseInt(box.getAttribute('data-akp-eta-min') || '3', 10);
    var maxDays = parseInt(box.getAttribute('data-akp-eta-max') || '5', 10);
    var cutoff = box.getAttribute('data-akp-cutoff') || '3 pm';
    if (!input || !btn || !out) return;

    btn.addEventListener('click', function () {
      var value = (input.value || '').replace(/\s+/g, '');
      if (!/^\d{6}$/.test(value)) {
        out.textContent = 'Enter a valid 6-digit pincode.';
        out.setAttribute('data-state', 'error');
        return;
      }
      out.removeAttribute('data-state');
      out.innerHTML =
        'Delivery in <strong>' + minDays + '-' + maxDays + ' days</strong> to ' + value +
        '. Order before <strong>' + cutoff + '</strong> for same-day dispatch.';
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        btn.click();
      }
    });
  })();

  /* ------------------------------------------------------------------
     Accordions, one open per group (details + FAQ)
     ------------------------------------------------------------------ */
  root.querySelectorAll('[data-akp-accordion]').forEach(function (group) {
    group.querySelectorAll('.akp-accordion__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') === 'true';
        group.querySelectorAll('.akp-accordion__trigger').forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
          var panel = other.nextElementSibling;
          if (panel) panel.hidden = true;
        });
        if (!open) {
          trigger.setAttribute('aria-expanded', 'true');
          var panel = trigger.nextElementSibling;
          if (panel) panel.hidden = false;
        }
      });
    });
  });

  /* ------------------------------------------------------------------
     Scent finder quiz
     ------------------------------------------------------------------ */
  (function quiz() {
    var openBtn = root.querySelector('[data-akp-quiz-open]');
    var overlay = root.querySelector('[data-akp-quiz]');
    var poolEl = document.querySelector('[data-akp-pool]');
    if (!openBtn || !overlay || !poolEl) return;

    var pool = [];
    try {
      pool = JSON.parse(poolEl.textContent) || [];
    } catch (e) { pool = []; }

    var questions = [
      {
        key: 'who',
        q: 'Who is it for?',
        options: [
          { label: 'For her', value: 'women' },
          { label: 'For him', value: 'men' },
          { label: 'Unisex', value: 'unisex' }
        ]
      },
      {
        key: 'family',
        q: 'Which family do you lean toward?',
        options: [
          { label: 'Oud & oriental', value: 'oud' },
          { label: 'Fresh & aquatic', value: 'fresh' },
          { label: 'Sweet & vanilla', value: 'sweet' },
          { label: 'Floral & rose', value: 'floral' }
        ]
      },
      {
        key: 'occasion',
        q: 'When will you wear it?',
        options: [
          { label: 'Day & office', value: 'day' },
          { label: 'Evening & events', value: 'evening' },
          { label: 'Any time', value: 'any' }
        ]
      }
    ];

    var step = 0;
    var answers = {};
    var lastFocus = null;

    var panelQ = overlay.querySelector('[data-akp-quiz-question]');
    var panelOptions = overlay.querySelector('[data-akp-quiz-options]');
    var stepLabel = overlay.querySelector('[data-akp-quiz-step]');
    var resultsEl = overlay.querySelector('[data-akp-quiz-results]');
    var closeBtn = overlay.querySelector('[data-akp-quiz-close]');

    function focusables() {
      return Array.prototype.slice.call(
        overlay.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) { return !el.disabled && el.offsetParent !== null; });
    }

    function open() {
      lastFocus = document.activeElement;
      step = 0;
      answers = {};
      overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      renderStep();
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      overlay.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function renderStep() {
      if (resultsEl) {
        resultsEl.hidden = true;
        resultsEl.innerHTML = '';
      }
      if (stepLabel) stepLabel.textContent = 'Question ' + (step + 1) + ' of ' + questions.length;
      var current = questions[step];
      if (panelQ) panelQ.textContent = current.q;
      if (!panelOptions) return;
      panelOptions.innerHTML = '';
      panelOptions.hidden = false;
      current.options.forEach(function (opt) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'akp-quiz__option';
        b.textContent = opt.label;
        b.addEventListener('click', function () {
          answers[current.key] = opt.value;
          step += 1;
          if (step < questions.length) renderStep();
          else renderResults();
        });
        panelOptions.appendChild(b);
      });
    }

    function score(p) {
      var s = 0;
      var gender = (p.gender || '').toLowerCase();
      var family = (p.family || '').toLowerCase();
      var tags = (p.tags || '').toLowerCase();
      var bestFor = (p.bestFor || '').toLowerCase();

      if (answers.who === 'unisex') s += gender === 'unisex' ? 2 : 1;
      else if (answers.who && gender === answers.who) s += 3;
      else if (gender === 'unisex') s += 1;

      if (answers.family) {
        if (family.indexOf(answers.family) !== -1 || tags.indexOf(answers.family) !== -1) s += 3;
        if (answers.family === 'fresh' && (tags.indexOf('aquatic') !== -1 || tags.indexOf('fresh') !== -1)) s += 1;
        if (answers.family === 'sweet' && (tags.indexOf('vanilla') !== -1 || tags.indexOf('gourmand') !== -1 || tags.indexOf('sweet') !== -1)) s += 1;
        if (answers.family === 'floral' && tags.indexOf('floral') !== -1) s += 1;
        if (answers.family === 'oud' && tags.indexOf('oud') !== -1) s += 1;
      }

      if (answers.occasion === 'day' && /office|day|everyday|casual/.test(bestFor)) s += 2;
      if (answers.occasion === 'evening' && /evening|night|festive|occasion|date/.test(bestFor)) s += 2;
      if (answers.occasion === 'any') s += 1;

      return s;
    }

    function renderResults() {
      if (panelQ) panelQ.textContent = 'Your matches';
      if (stepLabel) stepLabel.textContent = 'Results';
      if (panelOptions) panelOptions.hidden = true;
      if (!resultsEl) return;
      resultsEl.hidden = false;
      resultsEl.innerHTML = '';

      var ranked = pool
        .map(function (p) { return { p: p, s: score(p) }; })
        .filter(function (r) { return r.p.available; })
        .sort(function (a, b) { return b.s - a.s; })
        .slice(0, 3);

      if (!ranked.length) {
        resultsEl.innerHTML = '<li class="akp-quiz__empty">No matches found. Try different answers, or browse all perfumes.</li>';
        return;
      }

      ranked.forEach(function (r) {
        var p = r.p;
        var li = document.createElement('li');
        li.className = 'akp-result';
        var addAttr = p.variantId ? ' data-ak-add="' + p.variantId + '" data-ak-add-label="Add"' : ' disabled';
        li.innerHTML =
          '<a class="akp-result__media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' +
            (p.img ? '<img src="' + p.img + '" alt="" loading="lazy" width="120" height="120">' : '') +
          '</a>' +
          '<div class="akp-result__info">' +
            '<a class="akp-result__name" href="' + p.url + '">' + p.name + '</a>' +
            (p.inspired ? '<span class="akp-result__inspired">Inspired by ' + p.inspired + '</span>' : '') +
            '<span class="akp-result__price">' + money(p.price) + '</span>' +
          '</div>' +
          '<button type="button" class="akp-btn akp-btn--primary akp-result__add"' + addAttr + '>Add</button>';
        resultsEl.appendChild(li);
      });
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
  })();
})();
